import { useMemo } from 'react';
import {
  audioSupported,
  nativeHlsIsSupported,
  shakaStreamingSupported,
  shouldUseHlsUrl,
  shouldUseNativeHls
} from '@/helpers/audio';
import { isBrowser } from '@/helpers/browser';

const useAudioCompatibility = () => {
  const browserMode = isBrowser();

  const result = useMemo(() => (browserMode ? ({
    audioSupported: audioSupported(),
    nativeHlsSupported: nativeHlsIsSupported(),
    shakaSupported: shakaStreamingSupported(),
    shouldUseHlsUrl: shouldUseHlsUrl(),
    shouldUseNativeHls: shouldUseNativeHls()
  }) : {}), [browserMode]);
  
  return result;
};

export default useAudioCompatibility;